import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGetChatSettingsUnblockUserProperties } from "./useGetChatSettingsUnblockUserProperties";
import ChatSettingsDetails from "@/components/chat/chatSettings/ChatSettingsDetails/ChatSettingsDetails.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSettingsUnblockUser',
  setup(__props) {

const { unblockUserProperties } = useGetChatSettingsUnblockUserProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatSettingsDetails, _normalizeProps(_guardReactiveProps(_unref(unblockUserProperties))), null, 16))
}
}

})